import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { Seo } from "../components/Seo";
import { Footer } from "../components/Footer";
import { Button } from "../components/ui/button";
import { btnPrimary } from "../lib/ui";
import { ArrowRight } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const ContentPage = ({ page }) => {
  const [rec, setRec] = useState(null);
  useEffect(() => {
    axios.get(`${API}/posts`).then(({ data }) => {
      if (!data.length) return;
      const kws = (page.relatedKeywords || []).map((k) => k.toLowerCase());
      const match = data.find((p) => kws.some((k) => p.title.toLowerCase().includes(k)));
      setRec(match || data[0]);
    }).catch(() => {});
  }, [page]);

  return (
    <>
      <Seo title={page.title} description={page.meta} canonicalPath={page.path} />
      <main className="max-w-3xl mx-auto px-5 sm:px-8 py-14">
        <nav className="text-xs text-[#94A3B8] mb-6">
          <Link to="/" className="hover:text-[#1E40AF]">Home</Link> / <span>{page.h1}</span>
        </nav>
        <h1 className="font-display text-3xl sm:text-4xl font-bold tracking-tight text-[#0F172A]">{page.h1}</h1>
        <p className="mt-5 text-lg leading-relaxed text-[#475569]">{page.intro}</p>

        <div className="mt-8 space-y-8">
          {page.sections.map((s, i) => (
            <section key={i}>
              <h2 className="font-display text-xl font-semibold text-[#0F172A]">{s.h}</h2>
              <p className="mt-2 text-[#475569] leading-relaxed">{s.p}</p>
            </section>
          ))}
        </div>

        <div className="mt-12 rounded-2xl border border-[#D0E2FF] bg-[#F0F6FF] p-8 text-center">
          <h2 className="font-display text-2xl font-semibold text-[#0F172A]">{page.cta}</h2>
          <p className="text-[#475569] mt-2">Flat $10 &middot; one free revision &middot; instant PDF.</p>
          <Link to="/create">
            <Button className={`${btnPrimary} rounded-full px-8 py-6 mt-5`} data-testid="content-cta">
              {page.cta} <ArrowRight className="w-4 h-4 ml-1" />
            </Button>
          </Link>
        </div>

        {rec && (
          <div className="mt-10 rounded-xl border border-[#D0E2FF] bg-white p-6" data-testid="recommended-reading">
            <div className="text-xs font-semibold uppercase tracking-wider text-[#94A3B8] mb-2">Recommended reading</div>
            <Link to={`/blog/${rec.slug}`} data-testid={`recommended-${rec.slug}`}
              className="font-display font-semibold text-[#1E40AF] hover:underline">
              {rec.title}
            </Link>
            {rec.metaDescription ? <p className="text-sm text-[#475569] mt-1">{rec.metaDescription}</p> : null}
          </div>
        )}

        <div className="mt-8 text-sm text-[#64748B]">
          Related:{" "}
          <Link to="/what-is-a-paystub" className="text-[#1E40AF] hover:underline">What is a paystub</Link> &middot;{" "}
          <Link to="/blog" className="text-[#1E40AF] hover:underline">Blog</Link>
        </div>
      </main>
      <Footer />
    </>
  );
};
